/* eslint-disable */
export default defineNuxtPlugin((_nuxtApp) => {
  const config = useRuntimeConfig()
  // TODO once tested, the condition can be changed to `if (process.env.DEPLOY_ENV !== 'production')` so pixel is
  // only loaded in the production environment
  if (process.env.DEPLOY_ENV === 'local') return
    !function(w, d) {
        if (!w.rdt) {
            var p = w.rdt = function() {
                p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
            };
            p.callQueue = [];
            var t = d.createElement("script");
            t.src = "https://www.redditstatic.com/ads/pixel.js";
            t.async = true;
            var s = d.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t, s);
        }
    }(window, document);
    rdt('init',config.public.redditPixelId);
    rdt('track', 'PageVisit');

  // Track page views after router navigation
  const router = useRouter()
  router.afterEach((_to) => {
    rdt('track', 'PageVisit');
  })
})
